import './App.css';
import { Route } from 'react-router-dom'
import { Button, ButtonGroup, Container } from '@chakra-ui/react'

import Home from './views/home'
import ChatView from './views/chatView.jsx'

function App() {
  return (
    <div className="App" id="app">
      <Container
       display={{ base: "flex", md: "flex" }}
      alignItems="center"
      flexDir="column"
      fontFamily={'Gilroy'}
      p={3}
      bg="white"
      w="100%"//{{ base: "100%"}}
      minW={'300px'}
      minH={'90%'}
      borderRadius="0 0 10px 10px"
      borderWidth="1px"
      boxShadow={"mainComp"}
      // backgroundColor={"bgs.bgsMain"}
      backgroundColor={"#fff"}
      backgroundImage={"url('./assets/BodyBG_alpha.png')"}
      backgroundSize={"cover"}
      boxShadow={"bxshd.mainComp_ChtBx"}
      >

        <Route path ="/" component ={Home} exact/>
        <Route path ="/chats"  component ={ChatView}/>
      </Container>
    </div>
  );
}

export default App;
